var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotAirBaloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.85202C6 4.98948 8.10729 2.60698 10.8914 2.09973C8.21282 5.30034 8.04713 9.87892 10.3943 13.25H13.6057C15.9529 9.87892 15.7872 5.30034 13.1086 2.09973C15.8927 2.60698 18 4.98948 18 7.85202C18 9.25843 16.8638 11.4724 15.5803 13.5248C15.6864 13.6542 15.75 13.8197 15.75 14C15.75 14.4142 15.4142 14.75 15 14.75H14.5856L14.023 17.0003C14.5647 17.0125 15 17.4554 15 18V20C15 21.1046 14.1046 22 13 22H11C9.89543 22 9 21.1046 9 20V18C9 17.4554 9.43533 17.0125 9.97698 17.0003L9.41442 14.75H9C8.58579 14.75 8.25 14.4142 8.25 14C8.25 13.8197 8.31365 13.6542 8.4197 13.5248C7.13618 11.4724 6 9.25843 6 7.85202ZM10.9606 14.75L11.5231 17H12.4769L13.0394 14.75H10.9606Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.11279C14.3333 5.95034 14.3333 10.0497 12 12.8872C9.66667 10.0497 9.66667 5.95034 12 3.11279Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotAirBaloon);
export default __webpack_public_path__ + "static/media/hot-air-baloon.5e6ab87899b202b700466ffef2620c2b.svg";
export { ForwardRef as ReactComponent };